import { useTranslation } from 'react-i18next';
import { IconCloudOff } from '@components/icons/icon-cloud-off';

export const AUTH_REDIRECT_DELAY_MS = 1000;

export const AuthErrorFallback = () => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-1 items-center justify-center py-16' data-testid='auth-error-fallback'>
      <div className='flex flex-col items-center gap-4 max-w-md px-6 text-center'>
        <IconCloudOff className='w-20 h-20 text-primary' />
        <h1 className='text-headline-m text-primary'>{t('errors:authErrorTitle')}</h1>
        <p className='text-body-m text-secondary'>{t('errors:authErrorSubtitle')}</p>
        <p className='text-body-s text-tertiary'>{t('errors:authErrorDescription')}</p>
        <div className='mt-2 w-48 h-1 rounded-full bg-tertiary overflow-hidden' data-testid='auth-error-progress'>
          <div
            className='h-full rounded-full bg-inverse'
            style={{ width: 0, animation: `auth-progress-fill ${AUTH_REDIRECT_DELAY_MS}ms linear forwards` }}
          />
        </div>
      </div>
    </div>
  );
};
